import { render, staticRenderFns } from "./TagsBtn.vue?vue&type=template&id=4fe175ad&scoped=true"
import script from "./TagsBtn.vue?vue&type=script&lang=js"
export * from "./TagsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe175ad",
  null
  
)

export default component.exports